<span class="bg-success" *ngIf="state == stateUsageCoupon.ASSOCIATE">
  {{'state.associate' | translate}}
</span>
<span class="bg-warning" *ngIf="state == stateUsageCoupon.USED">
  {{'state.used' | translate}}
</span>